import axios from '@/axios'
import { buildAccessQueryParams } from '@/utils/trackAccessAuth'

export async function getAccessStatus(orderId, { bypassKey, accessToken } = {}) {
  const params = {}
  if (bypassKey) {
    params.k = bypassKey
  }
  if (accessToken) {
    params.access_token = accessToken
  }
  const response = await axios.get(`order/${orderId}/access-status`, { params })
  return response.data
}

export async function verifyAccess(orderId, { code, type, bypassKey } = {}) {
  const params = buildAccessQueryParams()
  if (bypassKey) {
    params.k = bypassKey
  }
  const response = await axios.post(`order/${orderId}/verify-access`, {
    code,
    type,
  }, { params })
  return response.data
}
